<template>
  <!-- 保司管理 -->
  <div>
    <div class="search-box min">
      <div class="input-item">
        <span class="label">保司简称</span>
        <Input
          type="text"
          v-model="formList.name"
          placeholder="请输入"
          clearable
        />
      </div>
      <div class="input-item">
        <span class="label">保司code</span>
        <Input
          type="text"
          v-model="formList.code"
          placeholder="请输入保司code"
          clearable
        />
      </div>
      <div class="btn-item">
        <Button type="primary" @click="search">查询</Button>
      </div>
    </div>
    <div class="tools-box left">
      <!-- <Button class="addbtn" type="primary" ghost @click="addInsure"
        >+ 新增保司</Button
      > -->
      <Button class="addbtn" type="primary" ghost v-if="$units.pointAction('pro_4_1')" @click="$refs.importCompany.open();">+ 导入保险公司</Button>
    </div>
    <div class="table-box">
      <loading :isShow="loading" />
      <Table :columns="columns" :data="companyList">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="showDetail(row.id)">详情</span>
          <span class="table-btn" @click="toPageAbovepersonnel(row)">上号人员</span>
          <span class="table-btn" @click="deleteData(row.id)">删除</span>
        </template>
      </Table>
    </div>
    <div class="pageBox">
      <Page
        :total="allData.total"
        :current="allData.current"
        :page-size="allData.size"
        show-total
        @on-change="pageChange"
        style="text-align: center"
      />
    </div>
    <Modal v-model="detailModal" title="详情" :footer-hide="true" class="my-modal top" class-name="insuranceModal" width="720px">
      <div class="row">
        <div class="cell">
          <div class="label">保司code</div>
          <div class="value">{{ companyDetail.code }}</div>
        </div>
        <div class="cell">
          <div class="label">公司全称</div>
          <div class="value">{{ companyDetail.fullName }}</div>
        </div>
      </div>
      <div class="row">
        <div class="cell">
          <div class="label">公司简称</div>
          <div class="value">{{ companyDetail.name }}</div>
        </div>
        <div class="cell">
          <div class="label">联系电话</div>
          <div class="value">{{ companyDetail.mobile }}</div>
        </div>
      </div>
      <div class="row">
        <div class="cell">
          <div class="label">公司性质</div>
          <div class="value" v-if="companyDetail.companyType==1">总公司</div>
          <div class="value" v-if="companyDetail.companyType==2">分公司</div>
        </div>
        <div class="cell">
          <div class="label">所在区域(省市)</div>
          <div class="value">{{ companyDetail.province }}{{ companyDetail.city }}</div>
        </div>
      </div>
      <div class="row">
        <div class="cell">
          <div class="label">公司logo</div>
          <div class="value">
            <img
              :src="companyDetail.ico"
              style="width: 90px; max-height: 40px"
            />
          </div>
        </div>
        <div class="cell" v-if="companyDetail.companyType==2">
          <div class="label">所属总公司</div>
          <div class="value">{{ companyDetail.parentName }}</div>
        </div>
      </div>
    </Modal>
    <Modal
      v-model="addVisible"
      width="900px"
      class-name="addFormModal"
      :closable="false"
      :mask-closable="false"
    >
      <Form
        ref="addFormRef"
        :model="addForm"
        :rules="addFormRules"
        class="page-form less"
        :label-width="90"
      >
        <FormItem prop="code" label="保司code">
          <Input
            type="text"
            v-model.trim="addForm.code"
            :maxlength="32"
            :show-word-limit="true"
            placeholder="保司code"
            clearable
          ></Input>
        </FormItem>
        <FormItem prop="fullName" label="公司全称">
          <Input
            type="text"
            v-model.trim="addForm.fullName"
            :maxlength="64"
            :show-word-limit="true"
            placeholder="公司全称"
            clearable
          ></Input>
        </FormItem>
        <FormItem prop="name" label="公司简称">
          <Input
            type="text"
            v-model.trim="addForm.name"
            :maxlength="64"
            :show-word-limit="true"
            placeholder="公司简称"
            clearable
          ></Input>
        </FormItem>
        <FormItem
          prop="orderNum"
          label="排序"
          :rules="$units.formRule.number(false)"
        >
          <Input
            type="text"
            v-model="addForm.orderNum"
            placeholder="请输入排序"
            :maxlength="16"
            :show-word-limit="true"
            clearable
          ></Input>
        </FormItem>
        <FormItem prop="mobile" label="联系电话">
          <Input
            type="text"
            v-model="addForm.mobile"
            placeholder="联系电话"
            :maxlength="32"
            :show-word-limit="true"
            clearable
          ></Input>
        </FormItem>
        <FormItem prop="ico" label="公司logo">
          <upload :muti="false" :arr="addForm.ico" @upload="toloadFile" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="addVisible = false" ghost>取消</Button>
        <Button type="primary" :loading="btnLoading" @click="saveAddform()"
          >保存</Button
        >
      </div>
    </Modal>

    <!-- 导入保司 -->
    <import-company ref="importCompany" :getCompanyList="getCompanyList"></import-company>
  </div>
</template>
<script>
import upload from "@/components/commons/upload";
import { uploadFile } from "@/api/httpList";
import importCompany from './importCompany';
export default {
  components: { upload, importCompany },

  data: () => ({
    tabId: "",
    addForm: {
      code: "",
      fullName: "", // 保司全称
      name: "", // 保司简称
      mobile: "", // 企业公示联系电话
      ico: "", // 公司logo
      orderNum: 0, // 排序
      sourceType: "1", // 1平台；2非平台
    },
    addFormRules: {
      code: [
        {
          required: true,
          message: "请输入保司code",
          trigger: "blur",
        },
        {
          message: "保司code只能是字母或数字",
          validator(rule, value) {
            const reg = /^[0-9a-zA-Z]*$/i;
            return reg.test(value.trim());
          },
        },
      ],
      fullName: [
        { required: true, message: "请输入公司全称", trigger: "blur" },
      ],
      name: [{ required: true, message: "请输入公司简称", trigger: "blur" }],
      ico: [{ required: true, message: "请上传公司logo", trigger: "change" }],
    },
    formList: {
      code: "", // 保司code
      name: "", // 保司简称
    },
    columns: [
      {
        title: "序号",
        type: "index",
        width: 80,
        align: "center",
      },
      {
        title: "保司code",
        key: "code",
        width: 130,
        align: "center",
        tooltip: true,
      },
      {
        title: "保险公司简称",
        key: "name",
        minWidth: 100,
        align: "center",
        tooltip: true,
      },
      {
        title: "保险公司全称",
        key: "fullName",
        minWidth: 250,
        align: "center",
        tooltip: true,
      },
      {
        title: "公司性质",
        minWidth: 100,
        align: "center",
        tooltip: true,
        render: (h, params) => {
          if (params.row.companyType == 1) {
            return h("span", ["总公司"]);
          } else if (params.row.companyType == 2) {
            return h("span", ["分公司"]);
          } else {
            return h("span", ["-"]);
          }
        },
      },
      {
        title: "所在地区",
        minWidth: 150,
        align: "center",
        tooltip: true,
        render: (h, params) => {
          return h("span", [params.row.province, "-", params.row.city]);
        },
      },
      {
        title: "公司logo",
        type: "ico",
        minWidth: 100,
        align: "center",
        render: (h, params) => {
          return h("div", [
            h("img", {
              attrs: {
                src: params.row.ico,
                style: "width:90px;max-height:40px;",
              },
            }),
          ]);
        },
      },
      {
        title: "操作",
        slot: "action",
        width: 200,
        align: "center",
      },
    ],
    detailModal: false,
    addVisible: false, // 新增保司弹窗
    pageNo: 1,
    pageSize: 10,
    companyList: [], // 保司列表
    companyDetail: [], // 保司详情
    allData: {}, // 所有数据
    loading: false,
    userType: "", //用户类型
    btnLoading: false,
  }),
  
  created() {
    this.getCompanyList();
    this.userType = JSON.parse(localStorage.getItem("userInfo")).userType;
  },
  methods: {
    tabChange() {},
    // 上传
    toloadFile(file) {
      let formData = new FormData();
      formData.append("file", file);
      uploadFile(formData).then((res) => {
        this.addForm.ico = res.data[0].path;
      });
    },
    // 新增保司
    addInsure() {
      this.addVisible = true;
      this.$nextTick(() => {
        this.$refs.addFormRef && this.$refs.addFormRef.resetFields();
      });
    },
    // 新增保司
    saveAddform() {
      this.$refs["addFormRef"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          this.$http({
            url: "/buz/insuranceCompany/offline/enter",
            type: "POST",
            data: this.addForm,
          })
            .then((res) => {
              this.btnLoading = false;
              this.addVisible = false;
              if (res.httpCode == 1) {
                this.search();
                this.$notice.success("保存成功");
              }
            })
            .catch((e) => {
              this.btnLoading = false;
            });
        }
      });
    },
    //搜索
    search() {
      this.pageNo = 1;
      this.getCompanyList();
    },
    // 保司列表
    getCompanyList() {
      this.loading = true;
      let params = {
        name: this.formList.name, //名称
        code: this.formList.code, // 保司code
        pageSize: this.pageSize,
        pageNo: this.pageNo,
      };
      for (var key in params) {
        if (params[key] === "") {
          delete params[key];
        }
      }
      this.$http({
        url: "/buz/insuranceCompany/read/page",
        type: "POST",
        data: params,
        apiPermissionCode:'pro_4_0'
      })
        .then((res) => {
          this.loading = false;
          window.scrollTo(0, 0);
          this.companyList = res.data;
          this.allData = res;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    // 添加系统保司
    addInsuranceCompany() {
      this.$router.push("/offline/insuranceManage/addInsurance");

    },
    // 分页切换
    pageChange(i) {
      this.pageNo = i;
      this.getCompanyList();
    },
    // 保司详情
    showDetail(id) {
      this.$http({
        url: `/buz/insuranceCompany/${id}`,
        type: "get",
      }).then((res) => {
        this.detailModal = true;
        this.companyDetail = res.data;
      });
    },

    // 上号人员
    toPageAbovepersonnel(row) {
      this.$router.push({
        path:"/offline/insuranceManage/abovePersonnel",
        query:{
          supplierType:1,
          supplierId:row.id,
        }
      })
    },

    // 删除
    deleteData(id) {
      this.$notice.inquiry("确认删除操作？").then(async () => {
        this.$http({
          url: `/buz/insuranceCompany/del?id=${id}`,
          type: "GET",
        }).then((res) => {
          this.$Message.success("删除成功");
          this.pageNo = 1;
          this.getCompanyList();
        });
      });
    }
  },
};
</script>
<style lang='scss' scoped>
@import "./companyPage";
</style>